import React, { useState } from 'react';
import { connect } from 'react-redux';
import { formatarBigDecimal } from '../../util/numberUtil';

const coresEntrada = {
  normal: 'bg-success',
  total: 'bg-warning'
};

const coresSaida = {
  normal: 'bg-danger',
  total: 'bg-warning'
};

const TotalizadoresCentroCusto = ({ totalizadores }) => {
  const [showEntradas, setShowEntradas] = useState(true);
  const [showSaidas, setShowSaidas] = useState(true);

  if (!totalizadores || Object.keys(totalizadores).length === 0) {
    return null;
  }

  const saldo = totalizadores['SALDO'] || 0;
  const totalEntradas = totalizadores['ENTRADA']?.TOTAL_ENTRADA || 0;
  const totalSaidas = totalizadores['SAIDA']?.TOTAL_SAIDA || 0;

  return (
    <div className="mt-1">
      {/* ENTRADAS */}
      {'ENTRADA' in totalizadores && (
        <fieldset className="p-1 border rounded">
          <legend
            className="w-auto px-2 d-flex align-items-center"
            style={{ cursor: 'pointer', fontSize: '0.85rem', fontWeight: '600' }}
            onClick={() => setShowEntradas(!showEntradas)}
          >
            ENTRADAS&nbsp;
            <span style={{ fontSize: '0.85rem' }}>{showEntradas ? '▼' : '▶'}</span>
          </legend>
          {showEntradas && (
            <div className="row">
              {Object.entries(totalizadores['ENTRADA'])
                .filter(([tipo]) => tipo !== 'TOTAL_ENTRADA')
                .map(([tipo, valor]) => (
                  <div key={`ENTRADA-${tipo}`} className="col-md-2 col-sm-6">
                    <div className={`card text-white ${coresEntrada.normal}`}>
                      <div className="card-body p-1 text-center">
                        <h6 className="card-title text-uppercase" style={{ fontSize: '0.7rem', marginBottom: '0.2rem' }}>
                          {tipo}
                        </h6>
                        <p className="card-text font-weight-bold" style={{ fontSize: '0.85rem', marginBottom: 0 }}>
                          {formatarBigDecimal(valor)}
                        </p>
                      </div>
                    </div>
                  </div>
                ))}
            </div>
          )}
        </fieldset>
      )}

      {/* SAIDAS */}
      {'SAIDA' in totalizadores && (
        <fieldset className="p-1 border rounded">
          <legend
            className="w-auto px-2 d-flex align-items-center"
            style={{ cursor: 'pointer', fontSize: '0.85rem', fontWeight: '600' }}
            onClick={() => setShowSaidas(!showSaidas)}
          >
            SAÍDAS&nbsp;
            <span style={{ fontSize: '0.85rem' }}>{showSaidas ? '▼' : '▶'}</span>
          </legend>
          {showSaidas && (
            <div className="row">
              {Object.entries(totalizadores['SAIDA'])
                .filter(([tipo]) => tipo !== 'TOTAL_SAIDA')
                .map(([tipo, valor]) => (
                  <div key={`SAIDA-${tipo}`} className="col-md-2 col-sm-6">
                    <div className={`card text-white ${coresSaida.normal}`}>
                      <div className="card-body p-1 text-center">
                        <h6 className="card-title text-uppercase" style={{ fontSize: '0.7rem', marginBottom: '0.2rem' }}>
                          {tipo}
                        </h6>
                        <p className="card-text font-weight-bold" style={{ fontSize: '0.85rem', marginBottom: 0 }}>
                          {formatarBigDecimal(valor)}
                        </p>
                      </div>
                    </div>
                  </div>
                ))}
            </div>
          )}
        </fieldset>
      )}

      {/* TOTAIS */}
      <fieldset className="p-1 border rounded">
        <legend className="w-auto px-2 mb-1" style={{ fontSize: '0.85rem', fontWeight: '600' }}>TOTAIS</legend>
        <div className="row align-items-center">
          <div className="col-auto">
            <div className="card text-white bg-success">
              <div className="card-body p-1 text-center" style={{ minWidth: '80px' }}>
                <h6 className="card-title text-uppercase" style={{ fontSize: '0.7rem', marginBottom: '0.2rem' }}>
                  ENTRADAS
                </h6>
                <p className="card-text font-weight-bold" style={{ fontSize: '0.85rem', marginBottom: 0 }}>
                  {formatarBigDecimal(totalEntradas)}
                </p>
              </div>
            </div>
          </div>

          <div className="col-auto mb-1" style={{ fontSize: '1rem', fontWeight: '600' }}>
            -
          </div>

          <div className="col-auto">
            <div className="card text-white bg-danger">
              <div className="card-body p-1 text-center" style={{ minWidth: '80px' }}>
                <h6 className="card-title text-uppercase" style={{ fontSize: '0.7rem', marginBottom: '0.2rem' }}>
                  SAÍDAS
                </h6>
                <p className="card-text font-weight-bold" style={{ fontSize: '0.85rem', marginBottom: 0 }}>
                  {formatarBigDecimal(totalSaidas)}
                </p>
              </div>
            </div>
          </div>

          <div className="col-auto mb-1" style={{ fontSize: '1rem', fontWeight: '600' }}>
            =
          </div>

          <div className="col-auto mb-1">
            <div className={`card text-white ${saldo >= 0 ? 'bg-success' : 'bg-danger'}`}>
              <div className="card-body p-1 text-center" style={{ minWidth: '80px' }}>
                <h6 className="card-title text-uppercase" style={{ fontSize: '0.7rem', marginBottom: '0.2rem' }}>
                  SALDO
                </h6>
                <p className="card-text font-weight-bold" style={{ fontSize: '0.85rem', marginBottom: 0 }}>
                  {formatarBigDecimal(saldo)}
                </p>
              </div>
            </div>
          </div>
        </div>
      </fieldset>
    </div>
  );
};

const mapStateToProps = state => ({
  totalizadores: state.centroCusto.totalizadores || {}
});

export default connect(mapStateToProps)(TotalizadoresCentroCusto);
